module.exports = "/_next/static/images/minivan-8e855ae49226b1d41abb9c4bc9eb6ec9.jpg";